// src/pages/Mission.jsx
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
  .container { 
    width: min(1400px, 96vw); 
    margin: 0 auto; 
    padding: 0 18px; 
  }
`;

const Content = styled.div`
  padding: 40px 0;
  
  h1 {
    font-size: clamp(32px, 5vw, 48px);
    margin-bottom: 30px;
    color: var(--fg);
    text-align: center;
  }
  
  .section {
    background: var(--card);
    border: 1px solid var(--bdr);
    border-radius: var(--radius);
    padding: 40px;
    box-shadow: var(--shadow);
    margin: 30px 0;
    
    h2 {
      color: var(--primary);
      margin-bottom: 20px;
      font-size: 28px;
    }
    
    p {
      color: var(--muted);
      line-height: 1.7;
      margin-bottom: 20px;
      font-size: 16px;
    }
  }
  
  @media (max-width: 768px) {
    padding: 20px 0;
    
    .section {
      padding: 25px 20px;
      
      h2 {
        font-size: 24px;
      }
    }
  }
`;

export default function Mission() {
  const { t } = useTranslation();

  return (
    <Container>
      <div className="container">
        <Content>
          <h1>{t('mission.title', 'Миссия корпорации АСТОРИУС')}</h1>
          
          <div className="section">
            <h2>{t('mission.ourMission', 'Наша миссия')}</h2>
            <p>
              {t('mission.description', 'Создавать будущее наших клиентов через предоставление исключительных возможностей в сфере недвижимости. Мы стремимся быть надежным партнером в принятии важнейших жизненных решений, связанных с недвижимостью.')}
            </p>
            <p>
              {t('mission.values', 'Наши ценности основаны на профессионализме, честности и индивидуальном подходе к каждому клиенту. Мы верим, что качественный сервис и экспертные знания рынка недвижимости помогают людям находить не просто объекты, а дома своей мечты и выгодные инвестиции.')}
            </p>
          </div>
        </Content>
      </div>
    </Container>
  );
}